// @flow

import type {Action} from '../../types'
import type {HospitalState} from '../types'
import type {SetDistrictsPayload} from '../actions/setDistricts'

export function setDistrictsReducer(state: HospitalState, action: Action<SetDistrictsPayload>): HospitalState {

  return {
    ...state,
    districts: action.payload.districts,
  }
}
